<div class="x-section__headline" data-test-id="headline">
	<h2 class="mat-h1" tabindex="0" aria-labelledby="sr-label-aufg">{{ verfuegung.createdAt | formatDate }}</h2>
</div>

<div class="x-section__subline">
	<i class="material-icons" aria-hidden="true">playlist_add_check</i>
	<h3 class="mat-body margin-right-auto">Aufgaben</h3>
	@if ((verfuegung | hasResourceLink: 'createAufgabe') && !isKorrespondenz(verfuegung)) {
		<schir-int-client-button-round toolTip="Aufgabe zu Verfügung anlegen"
			(click)="openAufgabeDialog()" data-test-id="create-aufgabe" materialIcon="add"
			                           cssClass="focus-inwards-light schir-inline-button"/>
	}
</div>

<div class="x-section__main">

	<schir-int-client-spinner [stateResource]="aufgaben | async"/>

	@if ((aufgaben | async); as _aufgaben) {
		<ul class="c-list">
			@for (aufgabe of sort(_aufgaben.resource); track aufgabe) {
				<schir-int-client-aufgabe-in-verfuegung (openKorrespondenz)="openKorrespondenz(aufgabe)"
				                                        (openAufgabeDialog)="openAufgabeDialog(true, $event)" [aufgabe]="aufgabe"/>
			}
	</ul>
	}
</div>
<span id="sr-label-aufg" class="sr-only">{{ verfuegung.createdAt | formatDate }} Aufgaben</span>
